import { render, staticRenderFns } from "./OrylTile.vue?vue&type=template&id=1a033f68&scoped=true&"
import script from "./OrylTile.vue?vue&type=script&lang=js&"
export * from "./OrylTile.vue?vue&type=script&lang=js&"
import style0 from "./OrylTile.vue?vue&type=style&index=0&id=1a033f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a033f68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VFlex,VImg,VLayout,VSheet})
